import {DefaultTimelineMetadata} from "../../../../../util/types";
import {formatDateText} from "../../../../../util/formatter";
import {findMetadata} from "../../../../../util/helpers";
import Card from "../Card/Card";
import IconMediaconverter from "../../../../icons/IconMediaconverter.tsx";

export default function OntCard({metadata}: { metadata: DefaultTimelineMetadata[] }) {
    const ont_sent_date = findMetadata('ont_sent_date', metadata);
    const is_ont_sent = findMetadata('is_ont_sent', metadata);

    return <Card
        done={is_ont_sent}
        title="Fiberboks"
        icon={IconMediaconverter}
    >
        {ont_sent_date ?
            <>
                <p>Din fiberboks er på vej til din adresse.</p>
                <p className={'date'}>{formatDateText(ont_sent_date)}</p>
            </>
            :
            <>
                <p>Din fiberboks er snart på vej til din adresse.</p>
                <p className={'date'}>Afventer forsendelse</p>
            </>
        }
    </Card>
}
